import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, allowSenior = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="dot-blink text-muted"><span/><span/><span/></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly) {
    const allowed = user.role === "admin" || (allowSenior && user.role === "gestor_senior");
    if (!allowed) return <Navigate to="/analytics" replace />;
  }
  return children;
}
